export default "__VITE_ASSET__CULeSmjM__"